export enum EnumAuthorisationAction {
  'Authorised' = 1,
  'Eject Card',
  'Capture Card',
  'Deny, Allowed to Retry'
}
export namespace EnumAuthorisationAction {
  export function values() {
    return Object.keys(EnumAuthorisationAction).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
